import {
  ESuperSiteTargetingObjectEndpointParamsType,
  ESuperSiteTargetingObjectType,
  IChannelCronSummary,
  IChannelPerformanceSortByOptions,
  IEndpointRequestScore,
  ISuperSiteTargetingObject,
} from '~/src/dash/api/channels/channels_models';
import { parseNumber, parseString, transformModel } from '~/src/dash/api/resource-transforms';
import { deviceEnvironmentsAsMap } from '~/src/dash/utils/device-environments';
import { EDeviceTypesToString } from '~/src/dash/utils/devices';

export function ESuperSiteTargetingObjectTypeToString(e: ESuperSiteTargetingObjectType): string {
  switch (e) {
    case ESuperSiteTargetingObjectType.ENDPOINT_PARAM:
      return 'Endpoint Param';
    case ESuperSiteTargetingObjectType.WSEAT:
      return 'WSeat';
    case ESuperSiteTargetingObjectType.DEALID:
      return 'Deal ID';
    case ESuperSiteTargetingObjectType.APP_BUNDLE:
      return 'App Bundle';
    case ESuperSiteTargetingObjectType.DEVICE_ENVIRONMENT:
      return 'Device Environment';
    case ESuperSiteTargetingObjectType.DEVICE_TYPE:
      return 'Device Type';
  }
  return 'unknown';
}

export function ESuperSiteTargetingObjectEndpointParamsTypeToString(
  e: ESuperSiteTargetingObjectEndpointParamsType,
): string {
  switch (e) {
    case ESuperSiteTargetingObjectEndpointParamsType.CUSTOM_4:
      return 'CUSTOM_4';
    case ESuperSiteTargetingObjectEndpointParamsType.CUSTOM_5:
      return 'CUSTOM_5';
    case ESuperSiteTargetingObjectEndpointParamsType.CUSTOM_6:
      return 'CUSTOM_6';
    case ESuperSiteTargetingObjectEndpointParamsType.CUSTOM_7:
      return 'CUSTOM_7';
    case ESuperSiteTargetingObjectEndpointParamsType.CUSTOM_8:
      return 'CUSTOM_8';
  }
  return 'unknown';
}

export function extractSuperSiteTargetingValue(config: ISuperSiteTargetingObject): string {
  switch (config.SuperSiteTargetingObjectType) {
    case ESuperSiteTargetingObjectType.ENDPOINT_PARAM:
      if (
        config.CustomConfigEndpointParam === undefined ||
        config.CustomConfigEndpointParam === null
      ) {
        return '';
      }
      return (
        ESuperSiteTargetingObjectEndpointParamsTypeToString(
          config.CustomConfigEndpointParam.ParamType,
        ) +
        ': ' +
        config.CustomConfigEndpointParam.Value
      );
    case ESuperSiteTargetingObjectType.WSEAT:
      return config.CustomConfigOnlyString;
    case ESuperSiteTargetingObjectType.DEALID:
      return config.CustomConfigOnlyString;
    case ESuperSiteTargetingObjectType.APP_BUNDLE:
      return config.CustomConfigOnlyString;
    case ESuperSiteTargetingObjectType.DEVICE_ENVIRONMENT:
      return config.CustomConfigDeviceEnvironment.map((dE) => deviceEnvironmentsAsMap.get(dE)).join(
        ', ',
      );
    case ESuperSiteTargetingObjectType.DEVICE_TYPE:
      return config.CustomConfigDeviceType.map((dE) => EDeviceTypesToString(dE)).join(', ');
  }
  return '';
}

export const transformEndpointRequestScore = transformModel<IEndpointRequestScore>({
  CountEndpointRequests: parseNumber(['CountEndpointRequests']),
  CountRequestHasAppBundle: parseNumber(['CountRequestHasAppBundle']),
  CountRequestHasAppBundleOrSitePage: parseNumber(['CountRequestHasAppBundleOrSitePage']),
  CountRequestHasAppName: parseNumber(['CountRequestHasAppName']),
  CountRequestHasAppStoreUrl: parseNumber(['CountRequestHasAppStoreUrl']),
  CountRequestHasContentCategory: parseNumber(['CountRequestHasContentCategory']),
  CountRequestHasContentChannel: parseNumber(['CountRequestHasContentChannel']),
  CountRequestHasContentGenre: parseNumber(['CountRequestHasContentGenre']),
  CountRequestHasContentID: parseNumber(['CountRequestHasContentID']),
  CountRequestHasContentNetwork: parseNumber(['CountRequestHasContentNetwork']),
  CountRequestHasContentRating: parseNumber(['CountRequestHasContentRating']),
  CountRequestHasContentTitle: parseNumber(['CountRequestHasContentTitle']),
  CountRequestHasIP: parseNumber(['CountRequestHasIP']),
  CountRequestHasMaxAdDuration: parseNumber(['CountRequestHasMaxAdDuration']),
  CountRequestHasMinAdDuration: parseNumber(['CountRequestHasMinAdDuration']),
  CountRequestHasPodDuration: parseNumber(['CountRequestHasPodDuration']),
  CountRequestHasPodDurationOrSlotCount: parseNumber(['CountRequestHasPodDurationOrSlotCount']),
  CountRequestHasSitePage: parseNumber(['CountRequestHasSitePage']),
  CountRequestHasSlotCount: parseNumber(['CountRequestHasSlotCount']),
  CountRequestHasUserAgent: parseNumber(['CountRequestHasUserAgent']),
});

export const transformChannelPerformanceSortByOptions =
  transformModel<IChannelPerformanceSortByOptions>({
    TotalRevenue: parseNumber(['TotalRevenue']),
    TotalRequests: parseNumber(['TotalRequests']),
    TotalImpressions: parseNumber(['TotalImpressions']),
  });

export const transformChannelCronSummary = transformModel<IChannelCronSummary>({
  Last24HrImpressions: parseString(['Last24HrImpressions']),
  PastWeekImpressions: parseString(['PastWeekImpressions']),
  Last24HrAverageCPM: parseString(['Last24HrAverageCPM']),
  PastWeekAverageCPM: parseString(['PastWeekAverageCPM']),
  Last24HrRevenue: parseString(['Last24HrRevenue']),
  PastWeekRevenue: parseString(['PastWeekRevenue']),
  Last24HrEndpointRequests: parseString('Last24HrEndpointRequests'),
  PastWeekEndpointRequests: parseString(['PastWeekEndpointRequests']),
});
